// import env from '@shared/config';

import { LoanApplication } from '@shared/api/@types/loans';
import env from '@shared/config';

import {
  UpsertLoanApplicationData,
  GetLoanOffersData,
  GetLoanApplicationsData,
  PreviewLoanAgreementData,
  PreviewLoanAgreementPayload,
  GetLoanData,
  ListUserLoansData,
  GetLoanAgreementsData,
} from '../generated/loansPublicApi.generated';
import { Methods, request } from '../rest';

const loansEndpoints = {
  syncLoanApplication: ({
    headers,
    data,
  }: {
    headers?: Record<string, string>;
    data: Partial<Omit<LoanApplication, '' | 'id'>>;
  }): UpsertLoanApplicationData =>
    request({
      path: '/applications/upsert',
      method: Methods.POST,
      data,
      headers,
      host: env.LOANS_HOST, // for local dev, ensure you have it in the .env
      auth: true,
    }),

  getLoanApplications: (): GetLoanApplicationsData =>
    request({
      path: '/applications/get',
      method: Methods.GET,
      host: env.LOANS_HOST,
      auth: true,
    }),

  getLoanOffers: (): GetLoanOffersData =>
    request({
      path: '/offers/get',
      method: Methods.GET,
      host: env.LOANS_HOST,
      auth: true,
    }),

  getLoanAgreement: ({ data }: { data: PreviewLoanAgreementPayload }): PreviewLoanAgreementData =>
    request({
      path: '/agreements/preview',
      method: Methods.POST,
      data,
      host: env.LOANS_HOST,
      auth: true,
    }),

  getLoan: ({ loanId }: { loanId: string }): GetLoanData =>
    request({
      path: `/${loanId}`,
      method: Methods.GET,
      host: env.LOANS_HOST,
      auth: true,
    }),

  getLoans: (): ListUserLoansData =>
    request({
      path: '/loans',
      method: Methods.GET,
      host: env.LOANS_HOST,
      auth: true,
    }),

  getLoanAgreements: ({ params }: { params: { loanId: string } }): GetLoanAgreementsData =>
    request({
      path: `/agreements/get/:loanId`,
      params,
      method: Methods.GET,
      host: env.LOANS_HOST,
      auth: true,
    }),
};

export default loansEndpoints;
